export function getErrorMessage(err: unknown): string {
  const e = err as {
    response?: { data?: { message?: string } }
    message?: string
  }
  return e?.response?.data?.message || e?.message || 'Request failed'
}
